<template>
<div id="addEdit">
  <el-dialog :title="formData.store_id?'编辑门店':'添加门店'" :visible.sync="visible" width="800px">

    <el-form :model="formData" :rules="rules" ref="form"  label-width="100px" class="demo-ruleForm" size="small">
      <el-form-item prop="name" label="门店名称">
        <el-input v-model="formData.name" placeholder="请输入门店名称"></el-input>
      </el-form-item>
      <el-form-item prop="category_id" label="门店分类">
        <el-select v-model="formData.category_id" placeholder="请选择门店分类" style="width: 100%;">
          <el-option v-for="item in cateList" :key="item.id" :label="item.name" :value="item.category_id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="service_ids" label="门店服务">
        <el-checkbox-group v-model="formData.service_ids" style="width: 100%;">
          <el-checkbox v-for="item in serviceList" :label="item.service_id" :key="item.id">{{ item.name }}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item prop="opening_hour" label="营业时间">
        <el-input v-model="formData.opening_hour" placeholder="请输入营业时间"></el-input>
      </el-form-item>

      <el-form-item prop="city_id" label="门店城市">
        <el-select v-model="formData.city_id" placeholder="请选择门店城市" style="width: 100%;">
          <el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.city_id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="address" label="门店地址">
        <el-input v-model="formData.address" placeholder="请输入门店地址"></el-input>
      </el-form-item>

      <el-form-item prop="lat" label="门店位置">
        <Getpoint  @getMapdata="getMapdataFunc" @chose="choseFunc"></Getpoint>
      </el-form-item>

      <el-form-item label="门店logo" prop="logo.file_id" :rules="[{ required: true, message: '请上传门店logo', trigger: 'change' }]">
        <el-button type="primary" @click="isupload=true;uploadType='logo'">选择图片</el-button>
        <div v-if="formData.logo.file_id" class="img">
          <img :src="formData.logo.file_path" width="100" height="100" />
        </div>
      </el-form-item>

      <el-form-item label="营业执照" prop="license.file_id" :rules="[{ required: true, message: '请上传营业执照', trigger: 'change' }]">
        <el-button type="primary" @click="isupload=true;uploadType='license'">选择图片</el-button>
        <div v-if="formData.license.file_id" class="img">
          <img :src="formData.license.file_path" width="100" height="100" />
        </div>
      </el-form-item>

      <el-form-item label="门店图片：" :rules="[{ required: true, message: '请上传门店图片' }]" prop="images">
      <div class="draggable-list">
        <div class="item" v-for="(item, index) in formData.images" :key="index">
          <img v-img-url="item.file_path" />
          <a href="javascript:void(0);" class="delete-btn" @click.stop="formData.images.splice(index,1)"><i class="el-icon-close"></i></a>
        </div>
        <!-- v-if="formData.images.length<8"  -->
        <div class="item img-select" @click="isupload=true;uploadType='images'"><i class="el-icon-plus"></i></div>
      </div>
    </el-form-item>

    <el-form-item label="绑定用户">
      <el-row>
        <el-button icon="el-icon-picture-outline" @click="userShow=!userShow">选择用户</el-button>
        <div v-if="formData.user_id&&formData.user_id!=''" class="img">
          <span>{{user_info.nickName}}</span>
          <img :src="user_info.avatarUrl" width="100" height="100" />
        </div>
      </el-row>
    </el-form-item>


    <el-form-item prop="is_home" label="是否首页展示">
      <el-radio-group v-model="formData.is_home" >
        <el-radio :label="1">是</el-radio>
        <el-radio :label="0">否</el-radio>
      </el-radio-group>
    </el-form-item>


    <el-form-item prop="sort" label="排序">
      <el-input v-model.number="formData.sort" placeholder="请输入排序"></el-input>
    </el-form-item>


    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="submitSave" :loading="loading">确定</el-button>
    </div>

  </el-dialog>

  <Upload v-if="isupload" :config="config" :isupload="isupload" @returnImgs="uploadChange">上传图片</Upload>

  <GetUser hasStore :is_open="userShow" @close="closeDialogFunc($event, 'add')"></GetUser>



</div>
</template>

<script>
import GetUser from '@/components/user/GetUser.vue';
import draggable from 'vuedraggable';
import Getpoint from '@/components/map/Getpoint.vue';
import LeagueApi from '@/api/league'
import Upload from '@/components/file/Upload';
export default {
  components:{Upload,Getpoint,draggable,GetUser},
  data(){
    return{
      userShow:false,
      loading:false,
      visible:false,
      isupload:false,
      formData:{
        name:'',
        category_id:'',
        service_ids:[],
        address:'',
        city_id:'',
        lat:'',
        lng:'',
        logo:{},
        license:{},
        images:[],
        opening_hour:'',
        user_id:'',
        is_home:0,
        sort:1,
      },
      rules: {
        name: [{required: true, message: '请输入门店名称', trigger: 'blur'}],
        category_id: [{required: true, message: '请选择门店分类', trigger: 'change'}],
        service_ids: [{required: true, message: '请选择门店服务', trigger: 'change'}],
        opening_hour: [{required: true, message: '请输入营业时间', trigger: 'blur'}],
        city_id: [{required: true, message: '请选择门店城市', trigger: 'change'}],
        address: [{required: true, message: '请输入门店地址', trigger: 'blur'}],
        lat: [{required: true, message: '请选择门店位置', trigger: 'blur'}],
        lng: [{required: true, message: '请选择门店位置', trigger: 'blur'}],
        is_home: [{required: true, message: '请选择是否首页展示', trigger: 'change'}],
        sort: [{required: true, message: '请输入排序', trigger: 'blur'}],
      },
      uploadType:'',
      // cateList:[],
      // serviceList:[],
      // cityList:[],
      config:{
        total: 8,
        file_type: 'image'
      },
      user_info:{}
    }
  },
  props:{
    cateList:Array,
    serviceList:Array,
    cityList:Array,
  },
  methods:{

    closeDialogFunc(e){
      // console.log(e);
      if (e.type != 'error') {
        this.user_info = e.params[0];
        this.formData.user_id = e.params[0].user_id;
      }
      this.userShow = false;
    },

    /*提交保存*/
    submitSave(){
      let params = JSON.parse(JSON.stringify(this.formData));
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          let API=this.formData.store_id?'setStoreEdit':'storeAdd'
          LeagueApi[API](params).then(data => {
            this.$message({
              message: '保存成功',
              type: 'success'
            });
            this.visible=false
            this.$emit('refresh')
          }).finally(() => {
            this.loading = false;
          });
        }
      });
    },

    /*显示弹窗*/
    show(e){
      this.visible=true
      this.formData.store_id=null
      this.user_info={}
      this.$nextTick(()=>{
        this.$refs.form.resetFields()
        if(e&&e!=''){
          this.formData.store_id=e.store_id
          for(let i in this.formData){
            if(e[i]){
              this.formData[i]=e[i]
            }
          }
          this.formData.category_id=Number(e.category_id)
          this.formData.service_ids=e.service_ids.split(',').map(item=>Number(item))
          this.formData.logo={file_id:e.logo.file_id,file_path:e.logo.file_path}
          this.formData.license={file_id:e.license.file_id,file_path:e.license.file_path}
          this.formData.images=e.images.map(item=>({file_id:item.file_id,file_path:item.file_path}))
          if(e.user&&e.user!=''){
            this.user_info=e.user
          }
        }
        // console.log(this.formData);

      })
    },

    // 图片选择
    uploadChange(e){
      // console.log(e);
      let key=this.uploadType
      if(e&&e!=''){
        if(key!='images'){
          this.formData[key]=e[0];
        }else{
          // let max=8-this.formData[key].length
          // let eLen=e.length
          // if(eLen>max){
          //   e=e.slice(0,max)
          // }
          // for(let i in e){
            this.formData[key].push(...e);
         // }
        }
      }
      this.isupload=false
    },


   /*获取经纬度*/
   getMapdataFunc(e) {
  //  console.log(e);

  //     this.form.supplier.coordinate = e.data[0].toFixed(6) + ',' + e.data[1].toFixed(6);
    },
        /*选择的地址*/
    choseFunc(e){
      // console.log(e);

      this.formData.lat=e.location.lat
      this.formData.lng=e.location.lng
      this.formData.address=e.address
    },



  },

}
</script>

<style lang="scss" scoped>
.img{margin-top: 10px;}
.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>


// WEBPACK FOOTER //
// src/views/league/store/addEdit.vue